export * from './offene-gutachten-list.component';
export * from './offene-gutachten-list.component.module';